import { ReactComponent as StoreIcon } from "./StoreIcon.svg";

import Icon from "../Icon";

export default StoreIcon as any as Icon;
